export const getEditorOptions = placeholder => ({
  formats: [
    'bold',
    'bullet',
    'image',
    'outdent',
    'indent',
    'italic',
    'link',
    'list',
    'ordered',
    'underline',
  ],
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline'],
      ['link', 'image'],
      [{ list: 'bullet' }, { list: 'ordered' }],
      [{ indent: '-1' }, { indent: '+1' }],
    ],
  },
  placeholder: placeholder,
});
